import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasOvw202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_ovw_202605",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 153,
  clicks: 6,
  adsSpendDollars: 11,
  budgetDollars: 600,
  salesDollars: 71,
  bestEstimateRoas: 6.45,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.02,
  newCustomersAcquired: 1,
  reorderConversions: 0,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
